<template>
  <div class="dsb">
    <div class="qiehuan">
      <div v-if="cus === 0" style="color: white" class="fs-rem-16 bold" @click="changeLanguage('en')">
        English
        <i v-if="screenSize == 'lg'" class="iconfont" style="color: white;margin-left: 6px">&#xe63a;</i>
      </div>
      <div v-if="cus === 1" style="color: white" class="fs-rem-16 bold" @click="changeLanguages('zh')">
        中文
        <i v-if="screenSize == 'lg'" class=" iconfont" style="color: white;margin-left: 6px">&#xe63a;</i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Lang',
  data() {
    return {
      cus: 0,
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    screenSize() {
      return this.$store.getters.screenSize
    }
  },
  created() {
    console.log(this.$i18n.locale)
    if (this.$i18n.locale === 'zh') {
      this.cus = 0;
    } else {
      this.cus = 1;
    }
  },
  methods: {
    changeLanguage(lang) {
      this.cus = 1;
      this.$i18n.locale = 'en' // 设置给本地的i18n插件
      this.$store.dispatch('app/setLanguage', lang)
    },
    changeLanguages(lang) {
      this.cus = 0;
      this.$i18n.locale = 'zh' // 设置给本地的i18n插件
      this.$store.dispatch('app/setLanguage', lang)
    },
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Lang/index.vue